import { useSelector } from 'react-redux';
import SolutionGrid, {
  SolutionGridMode,
} from '../../../../components/solutionGrid';
import { Container, SectionTitle, Section } from '../style';
import {
  selectDraftTemplate,
  selectIsFetchingTemplates,
} from '../../../../slices/templates';
import { useAppDispatch } from '../../../../store';
import { Spin } from 'antd';

const SolutionGridForm = () => {
  const draftTemplate = useSelector(selectDraftTemplate);

  const isFetchingTemplates = useSelector(selectIsFetchingTemplates);

  return (
    <Container>
      <SectionTitle>Solution Grid</SectionTitle>
      <Section>
        {isFetchingTemplates ? (
          <Spin style={{ marginTop: 100 }} />
        ) : (
          <SolutionGrid
            templateId={String(draftTemplate?.templateID)}
            mode={SolutionGridMode.EDIT}
          />
        )}
      </Section>
    </Container>
  );
};

export default SolutionGridForm;
